import { getTestIds } from '../../utils/TestIds';
export const GetEditableTableListTID = (parentTestId)=>getTestIds(parentTestId);
